const appName = 'restaurant-reviews'; // eslint-disable-line no-unused-vars